import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ChevronThinRight = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M12 4C11.4477 4 11 4.44775 11 5C11 5.28813 11.1226 5.54713 11.3176 5.72963C11.32 5.732 22.5201 16 22.5201 16C22.5201 16 11.32 26.268 11.3176 26.2704C11.1226 26.4529 11 26.7118 11 27C11 27.5523 11.4477 28 12 28C12.2566 28 12.49 27.9025 12.667 27.7435C12.6697 27.7411 24.6758 16.7371 24.6758 16.7371C24.8823 16.5476 25 16.2802 25 16C25 15.7197 24.8824 15.4522 24.6758 15.2629C24.6758 15.2629 12.6697 4.25888 12.667 4.2565C12.4899 4.0975 12.2566 4 12 4V4Z" />
	</svg>
);

export default ChevronThinRight;
